
<template>
  <v-container id="core-view"
    fluid
    grid-list-xl
    fill-height>
    <v-layout
      justify-center
      align-center>
      <v-flex
        xs12
        sm8
        md6 lg5 xl4>
        <material-card
          v-if='!maintenance'
          :color="cardColor"
          :text="message"
          title="eCDS - Login">
          <v-form
            ref="form"
            v-model="validForm">
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12>
                  <v-text-field
                    id="email"
                    v-model="loginForm.username"
                    :rules="validators.username"
                    prepend-icon="mdi-account"
                    name="login"
                    label="Login"
                    type="text"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12>
                  <v-text-field
                    id="password"
                    v-model="loginForm.password"
                    :append-icon="
                      passwordType == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    :type="passwordType"
                    :rules="[validators.password]"
                    prepend-icon="mdi-lock"
                    name="password"
                    label="Password"
                    required
                    @click:append="showPwd"
                  />
                </v-flex>

                <v-flex
                  xs6
                  text-left>
                  <br>
                  <a @click="forgotPass">Forgot password</a>
                </v-flex>

                <v-flex
                  xs6
                  text-right>
                  <v-btn
                    id="loginButton"
                    :disabled="!validForm || loading"
                    :loading='loading'
                    color="primary"
                    class="mx-0 font-weight-light"
                    @click="login"
                  >Login</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
        <v-alert v-else type='error' prominent style="text-align:left">
          <h3>{{maintenance.title}}</h3>
          <div v-html="maintenance.message" />
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from '@/utils/validators'
import { mapState } from 'vuex'

export default {
  data: () => ({
    validForm: true,
    validators,
    loginForm: {
      username: '',
      password: ''
    },
    loading: false,
    passwordType: 'password',
    message: 'Please insert your credentials',
    cardColor: 'primary'
  }),
  computed: {
    ...mapState('app', ['config']),
    maintenance() {
      if(this.config.maintenance) {
        return this.config.maintenance.filter((el) => {
          return !el.allowLogin
        })[0]
      }
      return false
    },
  },
  mounted () {
  },
  methods: {
    login () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true

      // const rolesHome = {
      //   'Administrator': '/',
      //   'EMN User': '/'
      //   'Site':
      // }

      this.$store
        .dispatch('user/login', this.loginForm)
        .then(user => {
          const homeByRole = {
            'Administrator': '/dashboard',
            'EMN User': '/dashboard',
            'EMN Estimates': '/estimates',
            'Site': '/siterequest',
            'Monitor': '/siterequest'
          }
          const home = homeByRole[user.role] || '/'

          this.cardColor = 'success'
          const path = this.$route.query.redirect || home
          this.$router.push({ path })
          this.loading = false
        })
        .catch((e) => {
          let errorMessage="Authentication failed!";
          if(e.response.status===429){
            errorMessage=e.response.data.message
          }
          this.loading = false;
          this.message = errorMessage;
          this.cardColor = "error";
        });
    },
    forgotPass () {
      this.$router.push({ path: '/forgot-pass' })
    },
    showPwd () {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    }
  }
}
</script>
